import {useEffect, useState} from 'react';
import type {ReactNode} from 'react';

const PROVIDERS: Array<{id: string; label: string; icon: ReactNode}> = [
    {
        id: 'google',
        label: 'Google',
        icon: (
            <svg height="26" viewBox="0 0 48 48" width="26">
                <path d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 4.1 29.3 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22 22-9.8 22-22c0-1.5-.2-2.6-.4-3.5z" fill="#FFC107" />
                <path d="M5.3 14.7l6.6 4.8C13.7 16 18.4 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 4.1 29.3 2 24 2 16.3 2 9.7 6.3 5.3 14.7z" fill="#FF3D00" />
                <path d="M24 46c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.5 2.4-7.2 2.4-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.6 41.6 16.2 46 24 46z" fill="#4CAF50" />
                <path d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.2-4.1 5.6l6.2 5.2C39.9 36.2 46 31 46 24c0-1.5-.2-2.6-.4-3.5z" fill="#1976D2" />
            </svg>
        )
    },
    {
        id: 'microsoft',
        label: 'Microsoft',
        icon: (
            <svg height="24" viewBox="0 0 24 24" width="24">
                <rect fill="#F25022" height="10" width="10" x="1" y="1" />
                <rect fill="#7FBA00" height="10" width="10" x="13" y="1" />
                <rect fill="#00A4EF" height="10" width="10" x="1" y="13" />
                <rect fill="#FFB900" height="10" width="10" x="13" y="13" />
            </svg>
        )
    }
];

export function ProviderButtonRow({onSelect}: {onSelect: (id: string) => void}) {
    const [lastUsedId, setLastUsedId] = useState<string | null>(null);

    useEffect(() => {
        setLastUsedId(localStorage.getItem('tt:last-provider'));
    }, []);

    return (
        <div className="provider-grid">
            <style>{`
                .provider-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 12px;
                }
                @media (max-width: 359px) {
                    .provider-grid {
                        grid-template-columns: 1fr;
                    }
                }
                .provider-card {
                    position: relative;
                    height: 96px;
                    border: 1px solid var(--tt-border);
                    border-radius: 12px;
                    background: var(--tt-card-bg);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 11px;
                    cursor: pointer;
                    transition: border-color 0.2s;
                }
                .provider-card:hover {
                    border-color: var(--tt-text-tertiary);
                }
                .provider-card span {
                    font-size: 14px;
                    font-weight: 600;
                    color: var(--tt-text-primary);
                }
                .provider-badge {
                    position: absolute;
                    top: -10px;
                    left: 50%;
                    transform: translateX(-50%);
                    background: color-mix(in srgb, var(--tt-green) 15%, transparent);
                    color: var(--tt-green);
                    font-size: 11px;
                    font-weight: 600;
                    padding: 3px 9px;
                    border-radius: 20px;
                    white-space: nowrap;
                }
            `}</style>
            {PROVIDERS.map(provider => (
                <button
                    key={provider.id}
                    className="provider-card"
                    type="button"
                    onClick={() => onSelect(provider.id)}
                >
                    {lastUsedId === provider.id && (
                        <div className="provider-badge">Last used</div>
                    )}
                    {provider.icon}
                    <span>{provider.label}</span>
                </button>
            ))}
        </div>
    );
}
